import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form'
import axios from 'axios'
import InputEmoji from "react-input-emoji";
import { ReactSession } from 'react-client-session';
import { Markup } from 'interweave';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import classes from './Comments.module.css'
import ReplyForm from './ReplyForm/ReplyForm';

const noAvatar = "https://hostpapasupport.com/knowledgebase/wp-content/uploads/2018/04/1-13.png";

function Comments(vid, type) {
    const navigate = useNavigate();
    const [objectId, setObjectId] = useState('');
    const [comments, setComments] = useState([]);
    const [totals, setTotals] = useState({
        mains: 0,
        nr: 0
    });
    const [text, setText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [height, setHeight] = useState(0);

    ReactSession.setStoreType("localStorage");
    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        if(type === 1) {
            setObjectId(`video_${vid}`);
        }else if(type === 2) {
            setObjectId(`image_${vid}`);
        }
    }, []);

    const getComments = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/comments.php`, {
            user_id: logged_user,
            object_id : objectId,
            action: 'GET_COMMENTS'
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then(response => {
            // console.log(response.data);
            if(response.data && response.data.status !== 'error') {
                setTotals({
                    mains: response.data.totals.mains,
                    nr: response.data.totals.nr
                });
                setComments(response.data.comments);
            }
        })
    };

    useEffect(() => {
        getComments();
    } , [objectId]);

    function handleOnEnter(txt) {
        // console.log("enter", text);
        // alert(text);
    }

    // const scrollTop = () => {
        
    // }

    useEffect(() => {
        function handleResize() {
            const el = document.getElementById('comments');

            const elDistanceToTop = window.pageYOffset + el.getBoundingClientRect().top;

            setHeight(elDistanceToTop);
        }
        handleResize();
        window.addEventListener('resize', handleResize);
      }, []);
    
    const handleReply = () => {
        window.scrollTo(0, height);
    }

    const onSubmit = () => {
        if(logged_user) {
            setIsLoading(true);
            const toast_id = toast.loading("Please wait...");
            axios.post(`${process.env.REACT_APP_API_URL}/api/user/addcomment.php`, {
                user_id: logged_user,
                object_id: objectId,
                reply_id: 0,
                comment_text: text,
                action: 'addcomment'
            },{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                // console.log(res.data);
                getComments();
                setIsLoading(false);
                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false, closeOnClick: true, rtl: true});
                setText('');
            }).catch(err => {
                console.log(err);
            })
        }else {
            if(window.confirm("You must be logged in to comment.")) {
                navigate('/login');
            }
        }
    }

    const handleLike = (id) => {
        if(logged_user) {
            axios.post(`${process.env.REACT_APP_API_URL}/api/comments.php`, {
                    user_id: logged_user,
                    comment_id: id,
                    action: 'UPDATE_LIKE'
                }, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    // console.log(res.data);
                    let elm = document.getElementById(`comment_${id}`).getElementsByClassName(`${classes.like_btn}`);
                    if(res.data.added === '1') {
                        elm[0].classList.add(`${classes.active}`);
                    }else {
                        elm[0].classList.remove(`${classes.active}`);
                    }
                }).catch(err => {
                    console.log(err);
                })
        }
    }

    return (
        <div className={classes.comments}  id='comments'>
            <div className={classes.header}></div>
            <div className={classes.reply_comment}>
                <div className={classes.header + ` mb-4`}>
                    <i className="fa-regular fa-message"></i>
                    <span>{totals.nr ? totals.nr : 0}</span> Comments
                </div>
                <div className={classes.message}>
                    <div className={classes.avatar}>
                        <Link to={false}>
                            <img src={ReactSession.get('avatar')} onError={e => {e.target.src = noAvatar}} alt={ReactSession.get('name')} />
                        </Link>
                    </div>
                    <div className={classes.comment}>
                        <form>
                            <InputEmoji
                                value={text}
                                onChange={setText}
                                cleanOnEnter
                                onEnter={onSubmit}
                                placeholder="Type a message"
                                />
                            {/* <textarea {...register('register', { required: true })} defaultValue="Share what you think?" className='form-control' rows="3" /> */}
                            <button className='btn btn-primary' type="button" onClick={() => onSubmit()} disabled={isLoading}>Submit</button>
                        </form>
                    </div>
                </div>
            </div>
            <div className={classes.comments_list}>
                {/* <div className="header">
                    <span>Popular Comments</span>
                </div> */}

                {
                    comments && comments.map ? comments.map((comment, index) => {
                        return (
                            <div key={index}>
                                <div id={`comment_${comment.id}`} className={classes.single_comment}>
                                    <div className={classes.sender}>
                                        <Link to={false}>
                                            <img src={comment.sender_avatar} onError={e => {e.target.src = noAvatar}} alt={comment.sender_name} />
                                        </Link>
                                        <div className={classes.name_date}>
                                            <Link to={`/profile/${comment.sender_id}/${comment.nice_url}`}>{comment.sender_name}</Link> <span><span>.</span>{comment.created}</span>
                                        </div>
                                    </div>
                                    <div className={classes.comment_text}>
                                        <div className={classes.text}>{comment.comment_text}</div>
                                        <ul className={classes.btn}>
                                            <li className={classes.like_btn} onClick={() => handleLike(comment.id)}>
                                                <i className={`fa-solid fa-thumbs-up ${comment.isLiked ? classes.active : ''}`}></i> <span>Like</span>
                                            </li>
                                            {
                                                <ReplyForm vid={vid} type="1" reply={comment.id} />
                                            }
                                        </ul>
                                    </div>
                                </div>
                                {
                                    comment.replies && comment.replies.map && comment.replies.map((reply, index) => {
                                        return (
                                            <div id={`comment_${reply.id}`} className={classes.single_comment + ` ` + classes.reply} key={index}>
                                                <div className={classes.sender}>
                                                    <Link to={false}>
                                                        <img src={comment.sender_avatar} onError={e => {e.target.src = noAvatar}} alt={comment.sender_name} />
                                                    </Link>
                                                    <div className={classes.name_date}>
                                                        <Link to={`/profile/${comment.sender_id}/${comment.nice_url}`}>{comment.sender_name}</Link> <span><span>.</span>{reply.created}</span>
                                                    </div>
                                                </div>
                                                <div className={classes.comment_text}>
                                                    <div className={classes.text}><Markup content={reply.comment_text} /></div>
                                                    <ul className={classes.btn}>
                                                        <li className={classes.like_btn} onClick={() => handleLike(reply.id, this)}>
                                                            <i className={`fa-solid fa-thumbs-up ${reply.isLiked ? classes.active : ''}`}></i> <span>Like</span>
                                                        </li>
                                                        {
                                                            // <ReplyForm vid={vid} type="1" reply={comment.id} />
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }): <div className={classes.is_empty}>No comment yet</div>
                }
            </div>
        </div>
    )
}

export default Comments